// ============================================================
// documentPermissions.ts — (Batch 4) the UI mirror of the server's document
// delete rule (fileController canDeleteDocument): a document's owner is its
// UPLOADER. You can always delete your own; someone else's needs an admin or
// "Delete others' documents" (deleteOthersDocuments). The server is the gate —
// this only hides the button so nobody clicks into a 403.
// ============================================================
import { useCallback } from 'react'
import { useCasevoStore } from '../store/useCasevoStore'

export const useCanDeleteDocument = (): ((uploaderId: string | null | undefined) => boolean) => {
  const authUser = useCasevoStore((s) => s.authUser)
  return useCallback((uploaderId) => {
    if (!authUser) return false
    if (authUser.role === 'admin') return true
    if (uploaderId && uploaderId === authUser.id) return true
    return !!authUser.effectivePermissions?.deleteOthersDocuments
  }, [authUser])
}
